import React from "react";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import { Pluralize } from "components/common";
import { describeExpression } from "util/CronUtils";
import { TIME_UNITS } from "./CorrelationForm";
const _CorrelationSummary = class _CorrelationSummary extends React.Component {
  render() {
    const { config } = this.props;
    const {
      sources,
      rules,
      search_within_ms: searchWithinMs,
      execute_every_ms: executeEveryMs,
      _is_scheduled: isScheduled,
      use_cron_scheduling: useCronScheduling,
      cron_expression: cronExpression,
      cron_timezone: cronTimezone
    } = config;
    const searchWithin = extractDurationAndUnit(searchWithinMs, TIME_UNITS);
    const executeEvery = extractDurationAndUnit(executeEveryMs, TIME_UNITS);
    return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Correlate Events within"), /* @__PURE__ */ React.createElement("dd", null, searchWithin.duration, " ", searchWithin.unit.toLowerCase()), /* @__PURE__ */ React.createElement("dt", null, "Use Cron Scheduling"), /* @__PURE__ */ React.createElement("dd", null, useCronScheduling ? "yes" : "no"), useCronScheduling ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Cron Expression"), /* @__PURE__ */ React.createElement("dd", null, cronExpression), /* @__PURE__ */ React.createElement("dt", null, "Execute Correlation"), /* @__PURE__ */ React.createElement("dd", null, _CorrelationSummary.renderCronExpression(cronExpression)), /* @__PURE__ */ React.createElement("dt", null, "Timezone"), /* @__PURE__ */ React.createElement("dd", null, cronTimezone)) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Execute Correlation every"), /* @__PURE__ */ React.createElement("dd", null, executeEvery.duration, " ", executeEvery.unit.toLowerCase())), /* @__PURE__ */ React.createElement("dt", null, "Enable scheduling"), /* @__PURE__ */ React.createElement("dd", null, isScheduled ? "yes" : "no"), _CorrelationSummary.renderEvents(sources, rules));
  }
};
_CorrelationSummary.renderEvent = (source, rule) => {
  const notForPeriod = extractDurationAndUnit(rule.not_for_period, TIME_UNITS);
  let details;
  switch (rule.state_logic) {
    case "not_and":
      details = /* @__PURE__ */ React.createElement("dd", null, "Should not occur, and it is followed by another Event");
      break;
    case "not_for":
      details = /* @__PURE__ */ React.createElement("dd", null, "Should not occur in the next ", notForPeriod.duration, " ", notForPeriod.unit.toLowerCase());
      break;
    default:
      details = /* @__PURE__ */ React.createElement("dd", null, "Should occur ", rule.occurrence, " ", /* @__PURE__ */ React.createElement(Pluralize, { singular: "time", plural: "times", value: rule.occurrence }));
  }
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, /* @__PURE__ */ React.createElement("em", null, source.title || "No Event assigned")), details);
};
_CorrelationSummary.renderEvents = (sources, rules) => rules.map((rule, idx) => {
  const source = sources.find((s) => s.event_definition_id === rule.event_creator_equals) || {};
  return /* @__PURE__ */ React.createElement(React.Fragment, { key: rule.id }, /* @__PURE__ */ React.createElement("dt", null, "Event #", idx + 1), _CorrelationSummary.renderEvent(source, rule));
});
_CorrelationSummary.renderCronExpression = (expression) => {
  if (expression) {
    return describeExpression(expression);
  }
  return "Error: no cron expression specified!";
};
let CorrelationSummary = _CorrelationSummary;
export default CorrelationSummary;
